module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-57x57.4b8d52134c61be69fc18b7c6ead087aa.png";